import { dataLayerTracking } from "@/libs/gtmTracking";

export const GALoginButtonClickedEvent = ({ deviceType, buttonLocation = "header" }) => {
  dataLayerTracking({
    event: "login_button_clicked",
    button_location: buttonLocation,
    button_text: "Login",
    method: "mobileNumber",
    device_type: deviceType,
  });
};
